import {onFind} from "@elements/init-modules-in-scope";
import { getApi } from '@elements/form-validation';

export function init () {
    onFind('.js-form-validation-scroll', baseElement => {
        let formInstance;
        getApi(baseElement).then((formApi) => {
            formInstance = formApi.getFormInstance();
            formInstance.on('core.form.invalid', () => {
                window.scrollTo({
                    behavior: 'smooth',
                    top:
                        baseElement.getBoundingClientRect().top -
                        document.body.getBoundingClientRect().top -
                        300
                })
            });
        });
    });
}